import { getFileName } from '../../utils/duplicateHelpers';

const DRM_EXTENSIONS = /\.(m4p|m4b)$/i;

export const isDrmProtected = (filePath: string): boolean =>
  DRM_EXTENSIONS.test(filePath);

/**
 * Splits a path so the folder can be ellipsised while the filename — the part
 * that actually distinguishes two copies — stays fully readable.
 */
export const splitPath = (filePath: string): { dir: string; file: string } => {
  const file = getFileName(filePath);
  const dir = filePath.slice(0, Math.max(filePath.length - file.length, 0));
  return { dir, file };
};
